import React from "react";

// @material-ui/core
// core components
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import HelmTable from "components/Table/HelmTable";

export default function Helm() {
  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <MDBox>
            <HelmTable/>
          </MDBox>
        </Grid>
      </Grid>
    </div>
  );
}
